import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
/**
 * [Model] CompanyItem Parser
 */
var CompanyItem = /*#__PURE__*/function () {
  function CompanyItem() {
    _classCallCheck(this, CompanyItem);
  }
  return _createClass(CompanyItem, null, [{
    key: "parseV1",
    value:
    /**
     * Parse docs snake case data. Usually from Rails API.
     *
     * @param data - the object to parse
     */
    function parseV1(data) {
      var rowData = data || {};
      var company = new CompanyItem();
      company.id = rowData.ea_company_id || rowData.id;
      company.name = rowData.name;
      company.oxygenId = rowData.oxygen_id;
      return company;
    }

    /**
     * Parse docs camel case data. Usually from CP API.
     *
     * @param data - the object to parse
     */
  }, {
    key: "parseV2",
    value: function parseV2(data) {
      var rowData = data || {};
      var company = new CompanyItem();
      company.id = rowData.id;
      company.oxygenId = rowData.oxygenId;
      company.name = rowData.name;
      company.participated = rowData.participated;
      return company;
    }

    /**
     * Parse camel case data
     *
     * @param data - the object to parse
     */
  }, {
    key: "parseHQ",
    value: function parseHQ(data) {
      var rowData = data || {};
      var company = new CompanyItem();
      company.id = rowData.id;
      company.oxygenId = rowData.memberGroupId;
      company.name = rowData.name;
      company.status = rowData.status;
      company.imageUrl = rowData.imageUrl;
      return company;
    }
  }]);
}();
export { CompanyItem as default };